import styled from 'styled-components';

export const IndicatorsContainer = styled.div`

`
